<template>
  <el-dialog
    class="base-dialog"
    v-bind="$attrs"
    v-on="$listeners"
    :visible.sync="visible"
    :close-on-click-modal="false"
  >
    <slot></slot>
    <template #footer>
      <el-button
        v-if="showCancel"
        @click="cancel"
        :disabled="cancelDisabled"
        size="small"
        >{{ cancelText }}</el-button
      >
      <el-button
        v-if="showOk"
        type="primary"
        @click="ok"
        :loading="okLoading"
        :disabled="okDisabled"
        size="small"
        >{{ okText }}</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'base-dialog',
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    showOk: {
      type: Boolean,
      default: true,
    },

    showCancel: {
      type: Boolean,
      default: true,
    },
    okDisabled: Boolean,
    okLoading: Boolean,
    cancelDisabled: Boolean,
    okText: {
      type: String,
      default: '确 定',
    },
    cancelText: {
      type: String,
      default: '取 消',
    },
  },
  data() {
    return {}
  },
  computed: {
    visible: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('change', newValue)
      },
    },
  },
  methods: {
    cancel() {
      this.$emit('change', false)
    },
    ok() {
      this.$emit('ok')
    },
  },
}
</script>

<style lang="less">
.v-modal {
  background: #fff;
}
.base-dialog {
  .el-dialog {
    box-shadow: 3px 5px 18px rgba(0, 0, 0, 40%);
  }
}
</style>
